import {Component, OnDestroy, OnInit, ViewChild, EventEmitter, Output, OnChanges, Input} from '@angular/core';
import {LocalCustomerSettingsModel} from '../../../models/LocalCustomerSettingsModel';
import {LocalCustomerSettingService} from './service/local-customer.service';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Observable, Subscription} from 'rxjs';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {GenericArray} from '../../../models/GenericArray';
import * as toastr from 'toastr';
import {Offset} from '../../../models/Offset';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import { Router } from '@angular/router';
import {UsersService} from '../../users/service/users.service';

@Component({
  selector: 'app-local-customer',
  templateUrl: './local-customer.component.html',
  styleUrls: ['./local-customer.component.scss']
})
export class LocalCustomerComponent  extends BaseGeneralComponent  implements OnInit, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isLocalCustomerSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getAllSubscribe: Subscription;
  deleteElementSubscribe: Subscription;


  filter: LocalCustomerSettingsModel;
  offset: Offset;
  showNewEditDelete: boolean;
  showFilter: boolean;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() inServiceChanges?: boolean;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Output() elementSelected = new EventEmitter();

  constructor(private localCustomerSettingService: LocalCustomerSettingService,
              private userService: UsersService,
              private dialog: MatDialog, private loaderService: LoaderService,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.sectionId = this.SECTIONS.SETTINGS;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.filter = new LocalCustomerSettingsModel();
  }

  ngOnInit() {
    this.isLocalCustomerSection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = -1;

    this.displayedColumns = ['RegionDesc', 'LocalCustomerDesc', 'actions'];

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.LOCAL_CUSTOMER_SETTING_OFFSET);
    this.getSessionStorageFilter();
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.getDataPage(this.offset, this.filter);
  }

  getDataPage(offset: Offset, filter: LocalCustomerSettingsModel) {
    this.getAllSubscribe = this.localCustomerSettingService.getPage(offset, filter)
      .subscribe(
        (result: any) => {
          this.dataSource = result.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = result.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(localCustomer: any) {
    const localCustomerData = this.dataSource.find(data => data.localCustomer.cod === localCustomer.cod);
    const list: GenericArray[] = [
      {id: 'Region Cod',         value: this.toCustomString(localCustomerData.region.cod)},
      {id: 'Region Description', value:  this.toCustomString(localCustomerData.region.description)},
      {id: 'Local Customer Cod', value:  this.toCustomString(localCustomerData.localCustomer.cod)},
      {id: 'Local Customer Description', value:  this.toCustomString(localCustomerData.localCustomer.description)}
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.LOCAL_CUSTOMER_SETTING_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.loaderService.display(true);
        this.deleteElementSubscribe = this.localCustomerSettingService.softDelete(id)
          .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Local Customer with id ' + id + ' was deleted with success', 'Success');
              this.getDataPage(this.offset, this.filter);
            } else {
              toastr.info('Local Customer cannot be deleted', 'Alert');
            }
            this.loaderService.display(false);
          }, (error => {
              toastr.error('Local Customer with id ' + id + ' was not deleted', 'Error');
              this.loaderService.display(false);
          })
        );
    }
  }

  getDataFiltered(filter: LocalCustomerSettingsModel) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = filter;
    this.getDataPage(this.offset, this.filter);
  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }
  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getAllSubscribe) {
      this.getAllSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.LOCAL_CUSTOMER_SETTINGS_FILTER));
    this.filter = filter_ ? filter_ : new LocalCustomerSettingsModel();
  }
}
